var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotate = function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 18.6v3.8c0 .1-.1.3-.2.4-.1.1-.2.2-.4.2h-3.8c-.2 0-.4-.1-.5-.3-.1-.2-.1-.4.1-.6l1.2-1.2c-.8-.8-1.8-1.2-3-1.2-.6 0-1.2.1-1.7.3s-1 .5-1.4.9-.7.9-.9 1.4-.3 1.1-.3 1.7.1 1.2.3 1.7.5 1 .9 1.4.9.7 1.4.9 1.1.3 1.7.3c.7 0 1.3-.1 1.9-.4.6-.3 1.1-.7 1.5-1.3 0-.1.1-.1.2-.1s.2 0 .2.1l1.2 1.2c.1 0 .1.1.1.2s0 .1-.1.2c-.6.7-1.4 1.3-2.2 1.7-.9.4-1.8.6-2.8.6-.9 0-1.7-.2-2.5-.5s-1.5-.8-2.1-1.4c-.6-.6-1-1.3-1.4-2.1-.3-.8-.5-1.7-.5-2.5s.2-1.7.5-2.5.8-1.5 1.4-2.1c.6-.6 1.3-1 2.1-1.4.8-.3 1.7-.5 2.5-.5s1.6.2 2.4.5c.8.3 1.5.8 2.1 1.3l1.1-1.1c.2-.2.4-.2.6-.1.3.1.4.2.4.5z"
  })));
};
export default SvgRotate;